export const HOME_PAGE = 'home'
export const DETAIL_PAGE = 'blockDetail'
export const DOWNLOAD = 'pdf'
